import React, { useState, useRef, FC, useEffect } from 'react';
import { DraggableContainer, DraggableImg } from './styled';
import { Col } from '../flexDirection';

export const DraggableImage: FC<{
  src: string;
  scale: number;
  width?: string;
  height?: string;
}> = ({ src, width, height, scale }) => {
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [startY, setStartY] = useState(0);
  const [initialLeft, setInitialLeft] = useState<any>(0);
  const [initialTop, setInitialTop] = useState(0);
  const imgRef = useRef<HTMLImageElement | null>(null);

  const handleMouseDown = (e: any) => {
    if (imgRef.current) {
      setIsDragging(true);
      setStartX(e.clientX);
      setStartY(e.clientY);
      setInitialLeft(imgRef.current.offsetLeft);
      setInitialTop(imgRef.current.offsetTop);
      e.preventDefault();
    }
  };

  const handleMouseMove = (e: any) => {
    if (isDragging && imgRef.current) {
      const dx = e.clientX - startX;
      const dy = e.clientY - startY;
      imgRef.current.style.left = `${initialLeft + dx}px`;
      imgRef.current.style.top = `${initialTop + dy}px`;
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  return (
    <Col>
      <DraggableContainer
        className="container"
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseUp}
        $width={width}
        $height={height}
      >
        <DraggableImg
          src={src}
          alt="Draggable"
          ref={imgRef}
          onMouseDown={handleMouseDown}
          className="draggable"
          style={{ transform: `scale(${scale})`, width: width ? width : '500px' }}
        />
      </DraggableContainer>
    </Col>
  );
};
